import React, { useState } from "react";
import { Modal, Button, Header, Icon, Input } from "semantic-ui-react";
import "./warningInputModal.css"

export const WarningInputModal = ({
  open,
  onClose,
  header,
  placeholder = "lådnummer",
  needConfirmation = false,
  validateLength = 12,
  errorMessage = null
} : {
  open: boolean;
  onClose: (cancel: boolean, input: string) => void;
  header: string;
  placeholder?: string;
  needConfirmation?: boolean;
  validateLength?: number;
  errorMessage?: string | null
}) => {
  const [input, setInput] = useState<string>("");
  const [confirmationOpen, setConfirmationOpen] = useState<boolean>(false);

  const handleCancel = () => {
    onClose(true, input);
  };

  const handleConfirm = () => {
    onClose(false, input);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && input !== "" && input.length === validateLength) {
      if (!needConfirmation) {
        handleConfirm();
      } else {
        setConfirmationOpen(true);
      }
    }
  }

  if (confirmationOpen) {
    return (
      <Modal 
        open={open} onClose={handleCancel} size="small"
        closeOnEscape={false}
        closeOnDimmerClick={false}>
        <Header>
          <div className="cancellationHeaderContainer">
            <div className="cancellationHeader">
              <Icon size="big" name="warning sign" color="red"></Icon>
              Synkronisera kön
            </div>
          </div>
        </Header>
        <Modal.Content className="confirmationText">
          Vill du verkligen sätta <b>{input}</b> till första lådan i kön?
        </Modal.Content>
        <Modal.Actions>
          <Button color="green" onClick={() => handleConfirm()}>
            <Icon name="check" /> OK
          </Button>
          <Button color="red" onClick={handleCancel}>
            <Icon name="remove" /> Avbryt
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
  else {
    return (
      <Modal 
        open={open} onClose={handleCancel} size="small"
        closeOnEscape={false}
        closeOnDimmerClick={false}>
        <Header>
          <div className="cancellationHeaderContainer">
            <div className="cancellationHeader">
              <Icon size="big" name="warning sign" color="red"></Icon>
             {header}
            </div>
          </div>
        </Header>
        <Modal.Content>
          {errorMessage? (
           <div className="cancellationHeaderContainer">
             <div className="cancellationHeader">
             {errorMessage}
             </div>
           </div>): null}
          <Input
            autoFocus
            placeholder={placeholder}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => handleKeyPress(e)}
            className="warningModalInput"
          />
        </Modal.Content>
        <Modal.Actions>
          <Button color="red" onClick={handleCancel}>
            <Icon name="remove" /> Avbryt
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
};